import { defineMessages } from 'react-intl';

export const messages: {
	loginButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	loginAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	userAccountMenuAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	teamworkGraphBrand: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	navAbout: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	navConnectors: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	navCliFirst: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	navDocs: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	profileLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	logoutLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	loginButton: {
		id: 'twg-microsite.navbar.loginButton',
		defaultMessage: 'Log in',
		description: 'Button to log in to the application',
	},
	loginAriaLabel: {
		id: 'twg-microsite.navbar.loginAriaLabel',
		defaultMessage: 'Log in',
		description: 'Accessible label for the log in button',
	},
	userAccountMenuAriaLabel: {
		id: 'twg-microsite.navbar.userAccountMenuAriaLabel',
		defaultMessage: 'Account menu, {userName}',
		description:
			'Accessible label for the signed-in user avatar that opens the account menu. {userName} is the user display name.',
	},
	teamworkGraphBrand: {
		id: 'twg-microsite.navbar.teamworkGraphBrand.do-not-translate',
		defaultMessage: 'Atlassian Teamwork Graph',
		description: 'Teamwork Graph brand name shown in the nav bar',
	},
	navAbout: {
		id: 'twg-microsite.navbar.navAbout',
		defaultMessage: 'About',
		description: 'Navigation link to the About section of the microsite',
	},
	navConnectors: {
		id: 'twg-microsite.navbar.navConnectors',
		defaultMessage: 'Connectors',
		description: 'Navigation link to the Connectors section of the microsite',
	},
	navCliFirst: {
		id: 'twg-microsite.navbar.navCliFirst.do-not-translate',
		defaultMessage: 'CLI',
		description: 'Navigation link to the CLI section of the microsite',
	},
	navDocs: {
		id: 'twg-microsite.navbar.navDocs',
		defaultMessage: 'Docs',
		description: 'Navigation link to the documentation section of the microsite',
	},
	profileLabel: {
		id: 'twg-microsite.navbar.profileLabel',
		defaultMessage: 'Profile',
		description: 'Label and icon label for the Profile menu item in the user dropdown',
	},
	logoutLabel: {
		id: 'twg-microsite.navbar.logoutLabel',
		defaultMessage: 'Logout',
		description: 'Label and icon label for the Logout menu item in the user dropdown',
	},
});
